module.exports = __webpack_public_path__ + "static/media/perninoconsulting.5f3097b1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/perninoconsulting.webp
// module id = 673
// module chunks = 0